import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NewsTopic, NewsTopicUpdateRequest } from '@models/marketing/news-topics/news-topic.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class NewsTopicsService {
  private readonly url = `${environment.bffUrl}/news-topics`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<NewsTopic[]> {
    return this.http.get<NewsTopic[]>(`${this.url}`);
  }

  update(id: string, req: NewsTopicUpdateRequest): Observable<NewsTopic> {
    return this.http.put<NewsTopic>(`${this.url}/${id}`, req);
  }
}
